export default {"src":"/_next/static/media/flag.329a8654.svg","height":28,"width":19};